import React, { ComponentProps } from 'react';
import cn from 'classnames';
import { RadioGroup } from '@pwc/pwc-deals-ui';

import styles from './DraggableLibraryItemCardComponentTop.module.scss';

type TValueRadio = 'image' | 'web-table';

interface IITems {
  readonly excel?: {
    readonly cellRange?: {
      readonly id: number;
    };
  };
}

interface IProps {
  readonly initialValueRadio: TValueRadio;
  readonly items?: IITems;
  readonly onChangeValueRadio: (x: {
    readonly current: TValueRadio;
    readonly items?: IITems;
    readonly previous: TValueRadio;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  }) => any;
  readonly propsRoot?: ComponentProps<'div'>;
  readonly radioDisabled?: boolean;
}

interface IState {
  readonly valueRadio: TValueRadio;
}

export class ComponentTop extends React.Component<IProps, IState> {
  // eslint-disable-next-line react/state-in-constructor
  state = {
    // eslint-disable-next-line react/destructuring-assignment
    valueRadio: this.props.initialValueRadio,
  };

  componentDidUpdate(_prevProps: IProps, prevState: IState) {
    const { props, state } = this;

    if (state.valueRadio !== prevState.valueRadio) {
      props.onChangeValueRadio({
        current: state.valueRadio,
        items: props.items,
        previous: prevState.valueRadio,
      });
    }
  }

  handleFieldOnChange: React.ComponentProps<
    typeof RadioGroup
  >['field']['onChange'] = ({ target: { value } }) => {
    this.setState({ valueRadio: value as TValueRadio });
  };

  render() {
    const { props, state } = this;

    return (
      <div
        {...props.propsRoot}
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-call
        className={cn(
          'ck-editor-no-override-styles',
          styles.root,
          props.propsRoot?.className
        )}
      >
        <RadioGroup
          className="ck-editor-no-override-styles"
          classNameLabelRadioGroup="ck-editor-no-override-styles"
          disabled={props.radioDisabled}
          direction="row"
          field={{
            name: 'ComponentTop-DraggableLibraryItemCard',
            onChange: this.handleFieldOnChange,
            value: state.valueRadio,
          }}
          label="Display as:"
          options={[
            {
              label: 'Image',
              value: 'image' as TValueRadio,
            },
            {
              label: 'Web table',
              value: 'web-table' as TValueRadio,
            },
          ]}
        />
      </div>
    );
  }
}
